@if (!iconBtn) {
  <button
    mat-flat-button
	[ngClass]="{
		'outlined-btn': isOutlined,
		'big-btn': isBig,
		'pl-05 pr-05': isSmall,
		'pl-2 pr-2': !isSmall,
		bold: bold,
		'fixed-width': buttonText.length < 10 && !hasIcon
	}"
    (click)="onClick()"
    (blur)="onBlur()"
    [disabled]="isDisabled"
    [type]="type"
    class="base-btn"
    [color]="color"
    >
    @if (hasIcon) {
      <mat-icon class="material-symbols-outlined icon-btn">
        {{ iconName }}
      </mat-icon>
    }
    <span>{{ buttonText }}</span>
  </button>
}

@if (iconBtn) {
  <button
    mat-mini-fab
    [color]="color"
    (click)="onClick()"
    [ngClass]="{ 'outlined-btn': isOutlined }"
    >
    <mat-icon>
      {{ iconName }}
    </mat-icon>
  </button>
}
